import React from "react";
const ModeSvg = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10.4817 1.00004C8.40858 1.00007 6.38206 1.61484 4.65836 2.76659C2.93467 3.91834 1.59121 5.55535 0.797878 7.47061C0.00454634 9.38588 -0.203029 11.4934 0.201401 13.5266C0.60583 15.5598 1.6041 17.4275 3.06998 18.8934C4.04156 19.8746 5.19743 20.6541 6.4712 21.1873C7.74497 21.7204 9.11152 21.9966 10.4924 22C11.8732 22.0034 13.2411 21.7339 14.5175 21.2071C15.7938 20.6802 16.9535 19.9064 17.9299 18.93C18.9063 17.9536 19.6802 16.7939 20.207 15.5175C20.7339 14.2412 21.0034 12.8733 21 11.4925C20.9966 10.1116 20.7204 8.7451 20.1872 7.47135C19.6541 6.1976 18.8746 5.04173 17.8934 4.07016C16.9223 3.09377 15.7673 2.31968 14.495 1.7927C13.2228 1.26571 11.8587 0.996292 10.4817 1.00004ZM1.49723 11.4818C1.49723 6.52775 5.52759 2.49743 10.4817 2.49743V20.4661C5.52759 20.4661 1.49723 16.4358 1.49723 11.4818Z" />
    </svg>
  );
};

export default ModeSvg;
